import { createSelector } from "reselect";

const getNotificationFromStateAsArray = ({ notification }: any) => notification;
export const getNotification = createSelector(getNotificationFromStateAsArray, (getNotificationFromStateAsArray) => getNotificationFromStateAsArray);